<template>
      <div
        class="col-12 column"
        style="margin-bottom:30px;"
      >
        <div class="pane" v-if="announcement" style="text-align:center;">
          <h4 style="padding-top:20px">{{ announcement.title }}</h4>
          <p style="padding-top:10px;padding-bottom:10px;margin-left:10px;" :class="{
            'pane':true
            }">{{desc}}
            </p>
            <router-link to="/announcements">
              <button style="text-align:center;margin-bottom:10px;" class="btn btn-blue btn-primary">More Announcements</button>
            </router-link>
        </div>
      </div>
</template>

<script>
import Utils from "@/Utils/Utils";
import moment from 'moment';
export default {
  name: "MiniAnnouncementCard",
  components: {},
  data() {
    return {
      utils: Utils
    };
  },
  props: {
    announcement: {
    }
  },
  computed: {
    desc() {
      return this.announcement.description
    }
  },
  methods: {
    timeAgo(announcement) {
      return moment.utc(announcement.dateListed).format("MMM DD YY")
    },
    didClick() {
      this.$router.push(`/announcements`)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.pane {
  width: 100%;
  min-height: 25px;
  border-radius: 10px;
  margin-top: 20px;
  background: white;
  text-align: left;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniAnnouncement.vue